import { UUID } from "./types/common";
import Theme from "./types/theme";
// import * as dotenv from 'dotenv'

export enum Method {
  Get = "get",
  Post = "post",
  Patch = "patch",
  Delete = "delete",
}

export interface Route {
  path: string;
  method: Method;
  data?: any;
  params?: any;
  auth?: boolean;
  file?: File;
  extern?: boolean;
  skipHumps?: boolean;
  headers?: any;
  downloadFilename?: string;
}

// Prefer env var; fallback to same-origin /api/
export const BASE_URL: string =
  (typeof process !== "undefined" && (process as any).env?.BASE_URL_API) ||
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_BASE_URL_API) ||
  (typeof location !== "undefined" ? `${location.origin}/api/` : "/api/");

// Roles supported by the platform
export type UserRole = "admin" | "manager" | "apprenant";

// Compute frontend redirect path for a role
export function appPathForRole(role?: string): string {
  switch ((role || "").toLowerCase()) {
    case "admin":
    case "superadmin":
      return "/admin";
    case "manager":
    case "top_manager":
      return "/manager";
    case "user":
      return "/apprenant";
    default:
      return "/";
  }
}

const ROUTES: { [name: string]: (payload?: any) => Route } = {
  // Unified login for all roles; server decides role in JWT
  LOGIN: (data: { email: string; password: string }) => ({
    path: `users/login`,
    method: Method.Post,
    auth: false,
    data: { user: { email: data.email, password: data.password } },
  }),

  // Current user profile (to confirm role if not in JWT)
  ME: () => ({
    path: `users/me`,
    method: Method.Get,
    auth: true,
  }),

  ASK_PASSWORD_RESET: (data: { email: string }) => ({
    path: `users/reset_password`,
    method: Method.Post,
    data,
  }),
  ASK_PASSWORD_SET: (data: { email: string }) => ({
    path: `users/set_password`,
    method: Method.Post,
    data,
  }),
  RESET_PASSWORD: (data: { password: string; token: string }) => ({
    path: `users/reset_password/${data.token}`,
    method: Method.Patch,
    data,
  }),

  GET_CAMPAIGN_REGISTRATION_INFO: (data: { token: string }) => ({
    path: `campaigns/register/${data.token}`,
    method: Method.Get,
    auth: false,
  }),

  REGISTER_TO_CAMPAIGN: (data: {
    token: string;
    user: {
      first_name: string;
      last_name: string;
      email: string;
      password: string;
      password_confirmation: string;
    };
  }) => ({
    path: `campaigns/register/${data.token}`,
    method: Method.Post,
    auth: false,
    data: { user: data.user },
  }),
};

export default ROUTES;
